export const LIGHT = {
  bg: "#f8f9fc", bg2: "#ffffff", bg3: "#f1f3f8",
  border: "#e2e6ef", border2: "#d0d5e8",
  text: "#0f1117", text2: "#374151", text3: "#6b7280", text4: "#9ca3af",
  card: "#ffffff", cardBorder: "#e2e6ef",
  inputBg: "#f8f9fc", inputBorder: "#d0d5e8",
  headerBg: "#ffffff", headerBorder: "#e2e6ef",
  footerBg: "#f1f3f8", footerBorder: "#e2e6ef",
  tagMatchBg: "rgba(16,185,129,0.08)", tagMatchColor: "#059669", tagMatchBorder: "rgba(16,185,129,0.2)",
  tagMissBg: "rgba(239,68,68,0.08)", tagMissColor: "#dc2626", tagMissBorder: "rgba(239,68,68,0.2)",
  fixRowBorder: "#f1f3f8", shadow: "0 1px 3px rgba(0,0,0,0.08)", shadowLg: "0 10px 25px rgba(0,0,0,0.08)",
};

export const DARK = {
  bg: "#08080f", bg2: "#0f0f1a", bg3: "#141422",
  border: "#1e1e2e", border2: "#252535",
  text: "#f0f0f8", text2: "#c4c4d4", text3: "#8888a8", text4: "#55556a",
  card: "#0f0f1a", cardBorder: "#1e1e2e",
  inputBg: "#0a0a14", inputBorder: "#1e1e2e",
  headerBg: "#0a0a12", headerBorder: "#141422",
  footerBg: "#08080f", footerBorder: "#141422",
  tagMatchBg: "rgba(0,217,126,0.1)", tagMatchColor: "#00d97e", tagMatchBorder: "rgba(0,217,126,0.2)",
  tagMissBg: "rgba(255,77,109,0.1)", tagMissColor: "#ff4d6d", tagMissBorder: "rgba(255,77,109,0.2)",
  fixRowBorder: "#141422", shadow: "none", shadowLg: "0 10px 25px rgba(0,0,0,0.3)",
};

export const accent = "#6d28d9";
export const accentLight = "rgba(109,40,217,0.08)";
export const accentBorder = "rgba(109,40,217,0.2)";
